<div class="icon-message">
    <mat-icon *ngIf="icon">{{ icon }}</mat-icon><div class="icon-text" [ngClass]="{'empty-text': !value }">{{ displayValue }}</div>
</div>
